import { useSearchParams } from "react-router-dom";
import { Table } from "../../../features/Table";
import { type K2PdfPageSelection, columns } from "./columns";
import {
  type FilterK2PdfPageSelectionSchema,
  K2PdfPageSelectionFilter,
} from "./filter";

export const K2PdfPageSelectionTable = () => {
  const [searchParams] = useSearchParams();
  const client = searchParams.get("client") || "k2";
  const table_name = "k2_pdf_page_selection";

  return (
    <Table<K2PdfPageSelection, FilterK2PdfPageSelectionSchema>
      label="Sélection de pages PDF"
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<K2PdfPageSelectionFilter />}
      disable_translations_request={true}
      columnVisibilityInit={{
        tableau_view: false,
        tableau_workbook_id: false,
        created_at: false,
      }}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
